import { useState } from 'react';
import useDebounce from 'react-use/esm/useDebounce';

export interface UseDebouncedSearchResult {
  query: string;
  search: string;
  setSearch: (value: string) => void;
}
export const useDebouncedSearch = (
  debounceMs: number = 150,
): UseDebouncedSearchResult => {
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');

  useDebounce(() => setQuery(search), debounceMs, [search]);

  return { query, search, setSearch };
};
